export class SubscribeStatusError extends Error {
  status: string

  constructor(message: string, status: string) {
    super(message)
    this.name = 'SubscribeStatusError'
    this.status = status

    Object.setPrototypeOf(this, SubscribeStatusError.prototype)
  }

	toString(): string {
    return `${this.name} (Status: ${this.status}): ${this.message}`
  }
}